<app-modal-container
  [title]="title"
  [buttons]="modalButtons"
  [spinnerProps]="spinnerProps"
  [applyActivated]="applyActivated"
  (applyButtonClicked)="confirm(true)"
  (dismissButtonClicked)="confirm(false)">

  <div class="vertical-container width-60 column-gap-1">

    <div class="space-between-horizontal-centered row-gap-1">
      <div class="vertical-container width-100pcnt column-gap-0p25">
        <span class="line-height-120 bold500 caption-1">Companies</span>
        <app-checkbox-selector
          data-qa="companies-selector"
          [items]="companiesForSelector"
          [customText]="selectedCompanies.length === 1 ? selectedCompanies[0].item : selectedCompanies.length + ' companies'"
          [disabled]="companies.length === 1"
          (itemEmitter)="updateSelectedCompanies($event)"
        />
      </div>

      <app-selector
        data-qa="period-role-selector"
        class="width-100pcnt background-unset"
        [isNotInTable]="true"
        [data]="MetricDataRoleMap"
        [title]="'Table'"
        [disabled]="parent === 'single-company'"
        [field]="'name'"
        [selectedItem]="periodTypeForSelector"
        (itemEmitter)="updateViewByPeriodType($event)"
      />

      <app-selector
        data-qa="starting-year"
        class="width-100pcnt background-unset"
        [isNotInTable]="true"
        [title]="'Starting year'"
        [data]="startingYears.all"
        [field]="'year'"
        [selectedItem]="startingYears.selected"
        [defaultPlaceholder]="'Select starting'"
        [showTooltip]="false"
        [scrollIntoValue]="selectedPeriod.getFullYear()"
        (itemEmitter)="setStarting($event)">
      </app-selector>

      <app-selector
        data-qa="ending-year"
        class="width-100pcnt background-unset"
        [isNotInTable]="true"
        [title]="'Ending year'"
        [data]="endingYears.all"
        [field]="'year'"
        [selectedItem]="endingYears.selected"
        [defaultPlaceholder]="'Select ending'"
        [showTooltip]="false"
        (itemEmitter)="setEnding($event)">
      </app-selector>
    </div>

    <div *ngIf="!showPeriods" class="centered-vertically-column-container column-gap-1 height-10 bg-black-1">
      <app-all-icons
        [iconNameAndStyling]="'empty-tray.svg;icon-size-3p125 entered-row-container flex00auto'">
      </app-all-icons>
      <span class="font-2 bold600">Select starting & ending period</span>
    </div>

    <div *ngIf="showPeriods" class="table-fms pd-bttm-7">
      <table>
        <thead>
          <tr>
            <th>Period</th>
            <th>
              <app-checkbox
                data-qa="select-all-years"
                [checked]="selected === 'all'"
                [minus]="selected === 'some'"
                [disabled]="allSelectedDisabled"
                (checkBoxClicked)="selectAll()">
              </app-checkbox>
            </th>
            <th colspan="100%">Periods</th>
          </tr>
          </thead>
          <tbody>
            <tr *ngFor="let year of displayedPeriods">
              <td>{{ year.year }}</td>
              <td>
                <app-checkbox
                  [attr.data-qa]="'select-year-' + year.year"
                  [checked]="year.selected === 'all'"
                  [disabled]="year.allSelectedDisabled"
                  [minus]="year.selected === 'some'"
                  (checkBoxClicked)="selectYear(year)">
                  All
                </app-checkbox>
              </td>
              <ng-container *ngFor="let month of year.months">
                <td>
                  <app-checkbox
                    [attr.data-qa]="'select-month-' + month.name"
                    [checked]="month.selected"
                    [disabled]="month.disabled"
                    (checkBoxClicked)="selectMonth(month, year, $event)">
                    {{ month.name }}
                  </app-checkbox>
                </td>
              </ng-container>
            </tr>
          </tbody>
      </table>
    </div>
  </div>
</app-modal-container>
